'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lmealorama_AppRouter$ViewRecipeAppPage(recipeId_$_lo, recipeId_$_hi) {
  this.Vr = 0;
  this.Vs = 0;
  this.Vr = recipeId_$_lo;
  this.Vs = recipeId_$_hi;
}
export { $c_Lmealorama_AppRouter$ViewRecipeAppPage as $c_Lmealorama_AppRouter$ViewRecipeAppPage };
$p = $c_Lmealorama_AppRouter$ViewRecipeAppPage.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lmealorama_AppRouter$ViewRecipeAppPage;
/** @constructor */
function $h_Lmealorama_AppRouter$ViewRecipeAppPage() {
}
export { $h_Lmealorama_AppRouter$ViewRecipeAppPage as $h_Lmealorama_AppRouter$ViewRecipeAppPage };
$h_Lmealorama_AppRouter$ViewRecipeAppPage.prototype = $p;
$p.v = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().P(this, 1088124571, true);
});
$p.f = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lmealorama_AppRouter$ViewRecipeAppPage)) {
    var x_$_lo = this.Vr;
    var x_$_hi = this.Vs;
    var $x_1 = x$0;
    var x$1_$_lo = $x_1.Vr;
    var x$1_$_hi = $x_1.Vs;
    return (((x_$_lo ^ x$1_$_lo) | (x_$_hi ^ x$1_$_hi)) === 0);
  } else {
    return false;
  }
});
$p.m = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().J(this);
});
$p.q = (function() {
  return 1;
});
$p.r = (function() {
  return "ViewRecipeAppPage";
});
$p.g = (function(n) {
  if ((n === 0)) {
    return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$bL(this.Vr, this.Vs);
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__I__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), n);
});
function $isArrayOf_Lmealorama_AppRouter$ViewRecipeAppPage(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.jn)));
}
export { $isArrayOf_Lmealorama_AppRouter$ViewRecipeAppPage as $isArrayOf_Lmealorama_AppRouter$ViewRecipeAppPage };
var $d_Lmealorama_AppRouter$ViewRecipeAppPage = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lmealorama_AppRouter$ViewRecipeAppPage, "mealorama.AppRouter$ViewRecipeAppPage", ({
  jn: 1,
  au: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lmealorama_AppRouter$ViewRecipeAppPage as $d_Lmealorama_AppRouter$ViewRecipeAppPage };
//# sourceMappingURL=mealorama.-App-Router$-View-Recipe-App-Page.js.map
